import React from 'react';
import { TransformationMaturity } from '../../types';


interface TransformationTableProps {
    transformationData: TransformationMaturity[];
    onGrowthChange: (step_id: string, growth: string) => void;
    onNotesClick: (transformation: TransformationMaturity) => void;
}

const TransformationTable: React.FC<TransformationTableProps> = ({
    transformationData,
    onGrowthChange,
    onNotesClick
}) => {


    // Helper function to get background color based on growth
    const getGrowthBgColor = (growth: string): string => {
        switch (growth.toLowerCase()) {
            case 'noplan':
                return 'bg-gray-100';      // Neutral gray for no plans
            case 'notstarted':
                return 'bg-yellow-100';    // Light yellow for not started
            case 'inprogress':
                return 'bg-blue-100';      // Light blue for in progress
            case 'inproduction':
                return 'bg-green-100';     // Light green for in production
            default:
                return 'bg-transparent';
        }
    };

    return (
        <>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-transparent border-collapse border">
                    <thead>
                        <tr className="bg-transparent/5 text-[#002B5C] font-bold">
                            <th className="py-3 px-4 text-left border-b w-1/4">
                                Transformation Area
                            </th>
                            <th className="py-3 px-4 text-left border-b w-1/6">
                                Phase
                            </th>
                            <th className="py-3 px-4 text-left border-b">
                                Notes
                            </th>
                        </tr>
                    </thead>
                    <tbody className='text-sm'>
                        {transformationData.map((item, index) => (
                            <tr key={item.step_id} className={` hover:bg-gray-50`}>
                                <td className="py-3 px-4 border-b">{item.transformationArea}</td>

                                <td className={`py-3 px-4 border-b ${getGrowthBgColor(item.growth)}`}>
                                    <div className="relative">
                                        <select
                                            value={item.growth}
                                            onChange={(e) => onGrowthChange(item.step_id, e.target.value)}
                                            className="block w-full bg-transparent appearance-none cursor-pointer pr-8 focus:outline-none"
                                        >
                                            <option value="Select">Select</option>
                                            <option value="NotStarted">Not Started</option>
                                            <option value="InProgress">In Progress</option>
                                            <option value="InProduction">In Production</option>
                                            <option value="NoPlan">No Plans</option>
                                        </select>
                                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                            </svg>
                                        </div>
                                    </div>
                                </td>
                                <td className="py-3 px-4 border-b max-w-md">
                                    
                                    <button
                                        onClick={() => onNotesClick(item)}
                                        className={`text-[#0F2A4F] hover:text-blue-800 focus:outline-none flex items-center italic ${ item.notes ? '' : 'underline underline-offset-2'}`}
                                    >
                                        {item.notes ? item.notes : "Add Notes ->"}
                                    </button>
                                    
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default TransformationTable;
